import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useQuery } from '@tanstack/react-query'
import NotificationAPI from 'api/faber/NotificationAPI'
import AbstractAuditLogDataGrid from 'common/AbstractAuditLogDataGrid'
import { generateColumnHeader } from 'helpers/column-generator/generateColumnHeader'
import { ALL_EMAILS_LOG } from 'helpers/column-generator/generateColumnHeader'
import OrbitSession from 'hooks/useCookies'
import { EmailHistoryRecord } from 'types/api/faber/notification.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

function EmailSentLogsV2({ customerRow, expanded }: EmailLogProps) {
  const emailColumns = generateColumnHeader(ALL_EMAILS_LOG)
  const [emailRows, setEmailRows] = useState<EmailHistoryRecord[]>([])
  const faberToken = OrbitSession.get('faberToken')
  const userEmail =
    'userEmail' in customerRow ? customerRow.userEmail : customerRow.email
  const queryOptions = React.useMemo(
    () => ({
      userEmail: userEmail
    }),
    [userEmail]
  )

  const { isLoading: getAllEmailHistoryLoading, refetch: refetchEmail } =
    useQuery(
      ['getAllEmailHistory', [queryOptions]],
      async () => {
        const { userEmail } = queryOptions
        return NotificationAPI.getEmailNotificationHistory(
          userEmail,
          faberToken
        )
      },
      {
        onError: () => {
          toast.error('Error getting email notification history')
          setEmailRows([])
        },
        onSuccess: (res) => {
          if (res.data.data === null) {
            setEmailRows([])
          } else {
            setEmailRows(res.data.data)
          }
        },
        enabled: expanded === 'panel5'
      }
    )

  useEffect(() => {
    refetchEmail()
  }, [])

  return (
    <>
      <AbstractAuditLogDataGrid
        tableHeight='350px'
        columns={emailColumns}
        rows={emailRows}
        loading={getAllEmailHistoryLoading}
        getRowId={(row: EmailHistoryRecord) =>
          row.campaign_id + emailRows.indexOf(row)
        }
        pagination
      />
    </>
  )
}

export default EmailSentLogsV2

interface EmailLogProps {
  customerRow: SubscriptionsTableRows | GetAllFaberUsersDetails
  expanded: string | false
}
